import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class PaiementService {
  constructor(private httpClient: HttpClient) {}

  getData() {
    return this.httpClient.get(environment.Localurl + "paiement");
  }

  insertData(data) {
    return this.httpClient.post(environment.Localurl + "paiement", data);
  }

  deleteData(id) {
    return this.httpClient.delete(environment.Localurl + "paiement/" + id);
  }

  getOneData(id) {
    return this.httpClient.get(environment.Localurl + "paiement/" + id);
  }

  updateData(id, data) {
    return this.httpClient.put(environment.Localurl + "paiement/" + id, data);
  }
}
